import { render, staticRenderFns } from "./project_info.vue?vue&type=template&id=0c4fb5db&scoped=true&"
import script from "./project_info.vue?vue&type=script&lang=js&"
export * from "./project_info.vue?vue&type=script&lang=js&"
import style0 from "./project_info.vue?vue&type=style&index=0&id=0c4fb5db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4fb5db",
  null
  
)

export default component.exports